module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/fbbbb684f6ebfc31e7e176507d67a6ce.png";